import { render } from "./App.vue?vue&type=template&id=96ce2800&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=96ce2800&lang=css"

import exportComponent from "/Users/chengyanbin/Project/Kunshan/ksdm_exam/app/emulation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__